import { fmtCompactEur, fmtCompactUsers } from '../formatters.js';

const MONEY_BACK_USER_RETURN_VALUE = 500_000;

export default function PulsarDropsEconomics({ summary, variant = 'internal' }) {
  const generated = summary.moneyBackGeneratedAppAccounts ?? 0;
  const isInvestor = variant === 'investor';

  return (
    <div className="rounded-card border border-carbon-100 bg-white p-7">
      <div className="mb-5">
        <p className="caption text-carbon-400">Money Back</p>
        <h3 className="h3 mt-2">
          {isInvestor
            ? 'A controlled reward pool for activation and retention.'
            : 'One reward pool, many marketing angles.'}
        </h3>
        {isInvestor && (
          <p className="body-md text-carbon-500 mt-3 max-w-3xl">
            Money Back is a capped user-reward program: users receive visible return value when they
            fund wallets, use the card, upgrade, refer friends, or join partner campaigns. The
            investor metric is not installs alone; it is funded wallets, repeat card usage, retained
            users, and Pro upgrade moments.
          </p>
        )}
      </div>

      <div className="grid gap-3 md:grid-cols-2">
        <Metric
          label="User return value"
          value={fmtCompactEur(MONEY_BACK_USER_RETURN_VALUE)}
          sub="Visible rewards returned to users"
        />
        <Metric
          label="Reward-driven app accounts"
          value={fmtCompactUsers(generated)}
          sub="Accounts attributed to reward-led acquisition"
        />
      </div>
    </div>
  );
}

function Metric({ label, value, sub }) {
  return (
    <div className="rounded-box bg-carbon-50 border border-carbon-100 p-4">
      <p className="caption text-carbon-400">{label}</p>
      <p className="text-2xl font-semibold tracking-h2 num-tabular mt-2 leading-none">{value}</p>
      <p className="label text-carbon-500 mt-3">{sub}</p>
    </div>
  );
}
